export class LoadProtocolTaskInfoSnapshot {
  constructor(
    public readonly id: string,
    public readonly description: string,
    public readonly isBlocking: boolean = false,
    public readonly isFinished: boolean = false
  ) {}

  public asFinished(): LoadProtocolTaskInfoSnapshot {
    return new LoadProtocolTaskInfoSnapshot(this.id, this.description, this.isBlocking, true);
  }
}

export class TasksChangedEventArgs {
  constructor(public readonly tasks: LoadProtocolTaskInfoSnapshot[]) {}
}

export class TaskClickedEventArgs {
  constructor(public readonly task: LoadProtocolTaskInfoSnapshot, public readonly clickEventArgs: any) {}
}
